<template>
  <v-card-text>
    <!-- Back a la izquierda -->
    <a href="/" class="btn-back mt-5">
      <v-icon left>mdi-arrow-left</v-icon>
      Regresar
    </a>

    <!-- Contenido centrado -->
    <div class="center-content">
      <h2 class="mt-6">Recuperación de contraseña</h2>
      <p class="mt-4 mb-8 pa-0">
        Introduce el correo electrónico con el que creaste tu cuenta, y te
        enviaremos las instrucciones para restablecer tu contraseña.
      </p>

      <v-form>
        <v-text-field
          required
          outlined
          dense
          label="Correo electrónico"
          :rules="emailRules"
          v-model="email"
        />
        <!-- Botón: estilo normal para Interify; estilo ECI cuando isPortalEci=true -->
        <div class="btn-wrap" :class="{ eci: isPortalEci }">
          <v-btn
            :color="isPortalEci ? '#00A7E4' : 'primary'"
            :dark="true"
            :width="isPortalEci ? '236px' : undefined"
            :height="isPortalEci ? '48px' : undefined"
            :class="isPortalEci ? 'rounded-xxl' : ''"
            style="margin-top: 30px"
            @click="sendEmail"
            :disabled="!allFieldsValidated()"
          >
            Continuar
          </v-btn>
        </div>
      </v-form>
    </div>
  </v-card-text>
</template>

<script>
export default {
  name: "InputCorreo",
  props: {
    email: String,
    isPortalEci: { type: Boolean, default: false },
  },
  data() {
    return {
      emailRules: [
        (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!value || !value.length) return "El campo es requerido";
          return pattern.test(value) || "Dirección de correo incorrecta";
        },
      ],
    };
  },
  methods: {
    sendEmail() {
      this.$emit("sendEmail", this.email);
    },

    allFieldsValidated() {
      const validations = [this.emailRules[0](this.email)];
      return !!this.email && (validations[0] === true || validations[0] === "");
    },
  },
};
</script>

<style scoped>
.btn-back {
  color: #333333;
  text-decoration: none;
  font-family: "Montserrat";
  font-size: 14px;
  margin-left: 0;
  font-weight: 300;
  display: flex;
  align-items: center;
}

/*título y párrafo para ambos */
.center-content h2,
.center-content p {
  text-align: center;
}

h2 {
  font-size: 26px;
  color: #333333;
  line-height: 28px;
}
p {
  font-size: 12px;
  font-family: "Montserrat";
  font-weight: 400;
  color: #6d6f71;
  line-height: 20px;
}

/*wrapper para centrar el botón */
.btn-wrap {
  display: flex;
  justify-content: center;
}
</style>
